import { render, staticRenderFns } from "./RegionsList.vue?vue&type=template&id=08e8f423&scoped=true&"
import script from "./RegionsList.vue?vue&type=script&lang=js&"
export * from "./RegionsList.vue?vue&type=script&lang=js&"
import style0 from "./RegionsList.vue?vue&type=style&index=0&id=08e8f423&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8f423",
  null
  
)

export default component.exports